import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function MissionPage() {
	return (
		<main className="min-h-screen">
			{/* Hero Section */}
			<section className="relative py-20 px-4 overflow-hidden">
				<div className="absolute inset-0 z-0">
					<div className="absolute inset-0 bg-black/50 z-10"></div>
					<img
						src="/images/general/mission_img.jpg"
						alt="Students learning"
						fill
						className="object-cover"
						priority
					/>
				</div>
				<div className="max-w-6xl mx-auto relative z-20 text-center text-white">
					<h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
						Our Mission
					</h1>
					<p className="text-xl md:text-2xl max-w-3xl mx-auto">
						Transforming education in West Africa by making
						high-quality learning resources accessible to all
						students.
					</p>
				</div>
			</section>

			{/* Mission Section */}
			<section className="py-16 px-4 bg-white">
				<div className="max-w-6xl mx-auto">
					<div className="grid md:grid-cols-2 gap-12 items-center">
						<div className="space-y-6">
							<div className="w-20 h-1 bg-yellow-400"></div>
							<h2 className="text-3xl md:text-4xl font-bold">
								Our Mission
							</h2>
							<p className="text-gray-700 leading-relaxed">
								At Ighota!, we are committed to revolutionizing
								education and making it accessible to everyone.
								Established in 2021, our goal is to support
								students through cutting-edge virtual learning
								programs, particularly during adversity.
							</p>

							<div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 my-6">
								<p className="italic text-gray-700">
									"Education is a fundamental right, not a
									privilege."
								</p>
							</div>

							<p className="text-gray-700 leading-relaxed">
								The organization is committed to offering
								high-quality, free educational resources to all
								students, regardless of location or income.
								Their team of passionate educators provides
								comprehensive support across subjects to empower
								students, boost academic success, and make
								education universally accessible.
							</p>
						</div>
						<div className="relative h-full rounded-lg overflow-hidden shadow-xl">
							<img
								src="/placeholder.svg?height=800&width=600"
								alt="Students learning"
								fill
								className="object-cover"
							/>
						</div>
					</div>
				</div>
			</section>

			{/* Story Section */}
			<section className="py-16 px-4 bg-gray-50">
				<div className="max-w-6xl mx-auto">
					<div className="text-center mb-12">
						<div className="w-20 h-1 bg-yellow-400 mx-auto mb-6"></div>
						<h2 className="text-3xl md:text-4xl font-bold">
							Our Story
						</h2>
					</div>

					<div className="grid md:grid-cols-5 gap-8">
						{/* Timeline */}

						<div className="md:col-span-1 flex flex-col items-center">
							<div className="h-full relative">
								<div className="h-full bg-yellow-400 w-1 mx-2"></div>
								<div className="absolute top-0 -mt-2 w-5 h-5 rounded-full bg-yellow-400"></div>
								<div className="absolute top-1/3 -mt-2 w-5 h-5 rounded-full bg-yellow-400"></div>
								<div className="absolute top-2/3 -mt-2 w-5 h-5 rounded-full bg-yellow-400"></div>
								<div className="absolute bottom-0 -mb-2 w-5 h-5 rounded-full bg-yellow-400"></div>
							</div>
						</div>

						{/* Story Content */}
						<div className="md:col-span-4 space-y-12">
							<div className="flex flex-col md:flex-row gap-6">
								<div className="md:w-1/4 font-bold text-xl text-yellow-600">
									2021
								</div>
								<div className="md:w-3/4">
									<p className="text-gray-700 leading-relaxed">
										Ighota! was founded to support Nigerian
										secondary school students during the
										COVID-19 pandemic, with a mission to
										provide virtual science labs for rural
										areas. This initiative aimed to spark
										students' interest in chemistry,
										biology, and physics during a time of
										great educational disruption.
									</p>
								</div>
							</div>

							<div className="flex flex-col md:flex-row gap-6">
								<div className="md:w-1/4 font-bold text-xl text-yellow-600">
									2022
								</div>
								<div className="md:w-3/4">
									<p className="text-gray-700 leading-relaxed">
										As Ighota! grew, its vision expanded to
										meet the broader needs of students by
										offering comprehensive resources for the
										entire WAEC exam. This growth united a
										team of dedicated West African educators
										who share a strong belief in making
										high-quality education accessible to
										everyone.
									</p>
								</div>
							</div>

							<div className="flex flex-col md:flex-row gap-6">
								<div className="md:w-1/4 font-bold text-xl text-yellow-600">
									Present
								</div>
								<div className="md:w-3/4">
									<p className="text-gray-700 leading-relaxed">
										Ighota! believes education is a
										fundamental right, not a privilege. The
										organization provides free virtual
										learning and exam preparation resources
										to empower students, support their
										academic success, and drive lasting,
										transformative change in education.
									</p>
									<p className="text-gray-700 leading-relaxed mt-4">
										Join us on our journey to make education
										universally accessible and impactful for
										every student.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* Values Section */}
			{/* <section className="py-16 px-4 bg-white">
				<div className="max-w-6xl mx-auto">
					<div className="text-center mb-12">
						<div className="w-20 h-1 bg-yellow-400 mx-auto mb-6"></div>
						<h2 className="text-3xl md:text-4xl font-bold">
							Our Values
						</h2>
						<p className="text-lg text-gray-600 mt-4 max-w-3xl mx-auto">
							These core principles guide everything we do at
							Ighota!
						</p>
					</div>

					<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
						<Card className="border-t-4 border-yellow-400 hover:shadow-lg transition-shadow">
							<CardContent className="pt-6">
								<div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mb-4">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										className="h-6 w-6 text-yellow-600"
										fill="none"
										viewBox="0 0 24 24"
										stroke="currentColor">
										<path
											strokeLinecap="round"
											strokeLinejoin="round"
											strokeWidth={2}
											d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
										/>
									</svg>
								</div>
								<h3 className="text-xl font-bold mb-2">
									Accessibility
								</h3>
								<p className="text-gray-700">
									We believe quality education should be
									accessible to all students regardless of
									location or economic status.
								</p>
							</CardContent>
						</Card>

						<Card className="border-t-4 border-yellow-400 hover:shadow-lg transition-shadow">
							<CardContent className="pt-6">
								<div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mb-4">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										className="h-6 w-6 text-yellow-600"
										fill="none"
										viewBox="0 0 24 24"
										stroke="currentColor">
										<path
											strokeLinecap="round"
											strokeLinejoin="round"
											strokeWidth={2}
											d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
										/>
									</svg>
								</div>
								<h3 className="text-xl font-bold mb-2">
									Quality
								</h3>
								<p className="text-gray-700">
									We are committed to providing the highest
									quality educational resources created by
									expert educators.
								</p>
							</CardContent>
						</Card>

						<Card className="border-t-4 border-yellow-400 hover:shadow-lg transition-shadow">
							<CardContent className="pt-6">
								<div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mb-4">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										className="h-6 w-6 text-yellow-600"
										fill="none"
										viewBox="0 0 24 24"
										stroke="currentColor">
										<path
											strokeLinecap="round"
											strokeLinejoin="round"
											strokeWidth={2}
											d="M12 6v6m0 0v6m0-6h6m-6 0H6"
										/>
									</svg>
								</div>
								<h3 className="text-xl font-bold mb-2">
									Empowerment
								</h3>
								<p className="text-gray-700">
									We empower students to take control of their
									learning journey and achieve their academic
									goals.
								</p>
							</CardContent>
						</Card>

						<Card className="border-t-4 border-yellow-400 hover:shadow-lg transition-shadow">
							<CardContent className="pt-6">
								<div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mb-4">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										className="h-6 w-6 text-yellow-600"
										fill="none"
										viewBox="0 0 24 24"
										stroke="currentColor">
										<path
											strokeLinecap="round"
											strokeLinejoin="round"
											strokeWidth={2}
											d="M13 10V3L4 14h7v7l9-11h-7z"
										/>
									</svg>
								</div>
								<h3 className="text-xl font-bold mb-2">
									Innovation
								</h3>
								<p className="text-gray-700">
									We continuously innovate our teaching
									methods and technology to provide the best
									learning experience.
								</p>
							</CardContent>
						</Card>
					</div>
				</div>
			</section> */}

			{/* CTA Section */}
			<section className="py-16 px-4 bg-yellow-400">
				<div className="max-w-4xl mx-auto text-center">
					<h2 className="text-3xl md:text-4xl font-bold mb-6">
						Join Our Mission
					</h2>
					<p className="text-lg mb-8 max-w-2xl mx-auto">
						Help us make quality education accessible to every West
						African student. Together, we can transform lives
						through education.
					</p>
					<div className="flex flex-col sm:flex-row gap-4 justify-center">
						<Button className="bg-black hover:bg-gray-800 text-white px-8 py-6 text-lg">
							Join Our Mission
						</Button>
						<Button
							variant="outline"
							className="bg-white hover:bg-gray-100 text-black border-black px-8 py-6 text-lg">
							Support Us
						</Button>
					</div>
				</div>
			</section>
		</main>
	);
}
